<template>
  <div class="container">
    <!-- 主持人专区 -->
    <div class="search-tab">
      <el-button class="filter-btn" :class="searchForm.search_type == 10 ? 'active' : ''" type="text"
        @click="handleTab(10)">{{ $t("已通过") }}</el-button>
      <el-button class="filter-btn" :class="searchForm.search_type == 20 ? 'active' : ''" type="text"
        @click="handleTab(20)">{{ $t("待审核") }}</el-button>
    </div>
    <!-- 搜索 -->
    <div class="search-box df pb-30">
      <div class="search-list list1 df aic">
        <el-input v-model="searchForm.search_key" clearable :placeholder="$t('请输入')" class="f1"
          @keyup.enter.native="handleSearch()" @clear="handleSearch()"></el-input>
        <el-button type="text" class="btn fn" @click="handleSearch()">{{
          $t("搜索")
        }}</el-button>
      </div>
      <div class="search-list f1 list2">
        <el-select v-model="searchForm.tt_id" clearable :placeholder="$t('话题分类')" @change="handleSearch()">
          <el-option v-for="item in topicList" :key="item.tt_id" :label="item.tt_title" :value="item.tt_id">
          </el-option>
        </el-select>
      </div>
      <div class="search-list f1 list3">
        <el-select v-model="searchForm.area_level1" clearable :placeholder="$t('洲')" @change="handleSearch()">
          <el-option v-for="item in areaLv1List" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="search-list f1 list4">
        <el-select v-model="searchForm.area_level2" clearable :placeholder="$t('国家/区域')" @change="handleSearch()">
          <el-option v-for="item in areaLv2List" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="search-list list5">
        <el-button type="text" @click="handelOpenarticle(thumbsId)">{{
          $t("文章投稿")
        }}</el-button>
      </div>
    </div>

    <!-- 列表 -->
    <div class="post-box" v-loading="listLoading">
      <div class="list" v-for="(item, index) in listData" :key="item.ttar_id" @click="$navigateParams('/subject/info', {
        id: item.ttar_id,
        is_preview: 1
      })">
        <div class="title">
          <span class="essence" v-if="item.ttar_rec == 900">{{ $t("精1") }}</span>

          <span class="hot" style="background-color: #fdb906ff" v-if="item.ttar_rec == 1000">{{
            $t("顶1")
          }}</span>


          {{ item.ttar_title }}
        </div>
        <div class="df aic jcsb">
          <div>
            <div class="df aic mt-18">
              <div @click="(event) => handleaAvatar(event, item)">
                <el-avatar :size="24" :src="item.user_avatar_att_url">
                  <img src="@/assets/images/avatar.png" alt="">
                </el-avatar>
              </div>
              <span class="name">{{ item.user_nick_name }}</span>
              <span class="date">
                {{ item.create_time }}
              </span>
              <div class="df pl-18">
                <div class="li">
                  <span class="iconfont">&#xe611;</span>
                  <span class="text">{{ item.ttar_hits }}</span>
                </div>
                <div class="li">
                  <span class="iconfont">&#xe61b;</span>
                  <span class="text">{{ item.ttar_likes }}</span>
                </div>
                <div class="li">
                  <span class="iconfont">&#xe63e;</span>
                  <span class="text">{{ item.reply_count }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="btns">
            <template>
              <template v-if="item.ttar_status == 60 && myHostInfo">

                <!-- 置顶和置精华 -->
                <el-button v-if="item.ttar_rec === 10 && myHostInfo.tth_topup === 10" type="primary"
                  @click="handlerTopup(item.ttar_id)" class="btn1">{{ $t("置顶") }}</el-button>
                <el-button v-if="item.ttar_rec === 10 && myHostInfo.tth_essence === 10" type="primary"
                  @click="handleEssence(item)" class="btn2" :loading="item.is_loading">{{ $t("置精华") }}</el-button>

                <!-- 取消置顶和取消置精华 -->
                <el-button v-if="item.ttar_rec === 1000 && myHostInfo.tth_topup === 10" type="primary"
                  @click="cancelTopup(item)" class="btn3" :loading="item.is_loading">{{ $t("取消置顶") }}</el-button>
                <el-button v-if="item.ttar_rec === 900 && myHostInfo.tth_essence === 10" type="primary"
                  @click="handleEssence(item)" class="btn3" :loading="item.is_loading">{{ $t("取消置精华") }}</el-button>

              </template>

              <!-- 删除 -->
              <el-button type="primary" class="btn3" @click="handleDel($event, item.ttar_id)" v-if="
                item.ttar_status == 60 &&
                myHostInfo &&
                myHostInfo.tth_remove == 10
              ">{{ $t("删除") }}</el-button>
              <!-- 审核:终审未通过 且有 审核权限 -->
              <el-button type="primary" class="btn1" @click="handlerExamine(item.ttar_id)" v-if="
                item.ttar_status != 60 &&
                myHostInfo &&
                myHostInfo.tth_audit == 10
              ">{{ $t("审核") }}</el-button>
            </template>
          </div>
        </div>
      </div>

      <div class="pageing-box df aic jcc mt-36" v-if="listData.length > 0">
        <el-button type="text" class="add-btn" @click="handlePages(1)">{{
          $t("回首页")
        }}</el-button>

        <el-pagination :current-page="pagination.page" :page-size="pagination.size" :total="pagination.total"
          layout=" prev, pager, next,slot" @current-change="handleCurrentChange">
          <span class="jump-text">{{ $t("跳转") }}</span>
          <el-input-number :controls="false" v-model="jumpIndex" :min="1" :max="totalPages" @change="handleJump"
            size="small" class="jump-ipt pl-0 pr-0" style="width: 28px; margin-left: 8px" />
        </el-pagination>
        <el-button type="text" class="add-btn ml-11" @click="handlePages(totalPages)">{{ $t("去尾页") }}</el-button>
      </div>

      <div class="no-data pt-86" v-if="listData.length == 0">
        <img src="@/assets/images/empty_data.png" alt="" />
        <p>{{ $t("暂无数据") }}</p>
      </div>
    </div>

    <!-- 审核弹框 :examineLoading="examineLoading"-->
    <examine-model ref="postDialog" :id="ttar_id" :title="$t('话题文章审核')"
      @poster-submitted="posterSubmitted"></examine-model>
    <!-- 置顶弹框 -->

    <topup-model ref="topupDialog" :id="ttar_id" :topLoading="topLoading" :title="$t('置顶')"
      @poster-submitted="topupSubmitted"></topup-model>


    <!-- 文章投稿 -->
    <articleModel ref="articleDialog" :tt_id="thumbsId" :classData="tablist" @post-submitted="handlePostSubmitted" />

    <!-- 个人信息 -->
    <avatarTop ref="avatarDialog" @post-submitted="handlePublisherFollow" :id="id"
      :publisherFollowLoading="publisherFollowLoading" />
  </div>
</template>

<script>
import {
  getHostDealtAreaLv1List,
  getHostDealtAreaLv2List,
  getHostDealtList,
  setHostTopUp,
  setHostEssence,
  setHostAudit,
  setHostDelete,
} from "@api/topichost";
import { setArticleAdd } from "@api/active";
// 文章投稿
import articleModel from "@/components/articleModel.vue";
import { setuserfollowAdd,userDataLv2 } from "@api/home";

// 引入examineModel.vue
import examineModel from "@/components/examineModel.vue";
import topupModel from "@/components/topupModel.vue";

export default {
  components: {
    examineModel,
    topupModel,
    articleModel,
  },
  data() {
    return {
      id: 0, //发布者 弹窗的 用户ID
      ttar_id: 0, //话题文章ID
      examineLoading: false, //审核提交laoding
      topLoading: false, // 置顶提交loading
      listLoading: false,
      //关注 主持人loading
      followLoading: false,
      //发布者关注loading
      publisherFollowLoading: false,
      // 分页
      jumpIndex: "",
      totalPages: 0, //总页数
      pagination: {
        page: 1,
        total: 9,
        size: 10,
        last_page: 1,
      },
      // 搜索框
      searchForm: {
        search_type: 10,
        search_key: "",
        tt_id: "",
        area_level1: "",
        area_level2: "",
      },

      areaLv1List: [],
      areaLv2List: [],
      topicList: [],
      listData: [],
      myHostInfo: [],
      thisUserInfo: [],//当前登录人信息

      thumbsId: 0, //话题分类id
      tablist: [],
    };
  },
  mounted() {
    this.getAreaLv1();
    // 获取初始化数据
    this.getData();
    let topicListStr = localStorage.getItem("topicList");
    this.topicList = JSON.parse(topicListStr);
    this.tablist = this.topicList;

    // this.getCurrUserData();
  },
  methods: {
    // 获取第一层区域
    async getAreaLv1() {
      const resList = await getHostDealtAreaLv1List();
      this.areaLv1List = resList.data;
    },
    // 获取第二层区域
    async getAreaLv2() {
      const resList = await getHostDealtAreaLv2List({
        area_level1: this.searchForm.area_level1,
      });
      this.areaLv2List = resList.data;
    },
    // 获取话题 文章列表
    async getData() {
      this.listLoading = true;
      if (this.searchForm.area_level1 > 0) {
        this.getAreaLv2();
      } else {
        this.areaLv2List = [];
        this.searchForm.area_level2 = "";
      }
      const resList = await getHostDealtList({
        ...this.searchForm,
        page: this.pagination.page,
      });
      this.thumbsId = this.searchForm.tt_id;

      if (resList.status == 200 && resList.data && resList.data.topic_article_list) {
        this.pagination.total = resList.data.topic_article_list.total ?? 0;
        this.listData = resList.data.topic_article_list.data ?? [];

        this.pagination.last_page = resList.data.topic_article_list.last_page ?? 0;
        this.pagination.size = resList.data.topic_article_list.per_page ?? 0;


        this.totalPages = resList.data.topic_article_list.last_page ?? 0; // 计算总页数

        this.myHostInfo = resList.data.my_host_info;
      }
      this.listLoading = false;
    },

    handleCurrentChange(val) {
      this.pagination.page = val;
      this.getData();
    },

    // 跳转
    handleJump() {
      this.pagination.page = this.jumpIndex;
      this.getData();
    },

    handlePages(index) {
      this.pagination.page = index;
      this.getData();
    },

    //搜索
    handleSearch() {
      this.pagination.page = 1;
      this.getData();
    },
    // 切换搜索类型
    handleTab(searchType) {
      this.searchForm.search_type = searchType;
      this.pagination.page = 1;
      this.handleSearch();
    },

    // 头像显示个人信息

    handleaAvatar(event, item) {
      // 判断是否是实名用户
      if (
        item.ttar_type == 20 ||
        item.user_id == 0 ||
        item.user_nick_name == "" ||
        item.user_nick_name == null
      ) {
        return false;
      }
      event.stopPropagation(); // 阻止事件冒泡
      this.$refs.avatarDialog.openModal();

      this.id = item.user_id;
    },
    // 关注 发布者
    async handlePublisherFollow(id) {
      this.publisherFollowLoading = true;
      let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
      if (res.status == 200) {
        this.$message.success(res.msg);
      }
      setTimeout(() => {
        this.publisherFollowLoading = false;
      }, 1000);
    },

    // 文章投稿
    async handelOpenarticle(id) {
      let checkRes=await userDataLv2();
      if(checkRes.status!=200){
          return false;
      }
      this.thumbsId = id;
      // 没有登录信息，跳转到登录
      this.thisUserInfo = JSON.parse(localStorage.getItem('userinfo'));
      if (this.thisUserInfo.user_id === undefined || this.thisUserInfo.user_id < 1) {
        this.$jumpLogin();
        return false;
      }
      setTimeout(() => {
        this.$refs.articleDialog.openModal();
      }, 20);
    },

    // 发布文章
    async handlePostSubmitted(content) {
      content.other_lang[0] = content.other_lang[0] ? 2 : 0;
      content.other_lang[1] = content.other_lang[1] ? 3 : 0;

      let res = await setArticleAdd(content);
      if (res.status == 200) {
        this.$message.success(res.msg);
      }
    },

    // 打开审核模态框
    handlerExamine(ttar_id) {
      event.stopPropagation(); // 阻止事件冒泡
      this.ttar_id = ttar_id;
      this.$refs.postDialog.openModal();
    },
    // 审核提交
    async posterSubmitted(e) {
      this.examineLoading = true;
      const res = await setHostAudit(e);
      setTimeout(() => {
        this.examineLoading = false;
      }, 1000);
      if (res.status == 200) {
        this.$message.success(res.msg);
        this.$refs.postDialog.closeModal();
        this.getData();
      }
    },

    //打开置顶模态框
    handlerTopup(ttar_id) {

      event.stopPropagation(); // 阻止事件冒泡
      this.ttar_id = ttar_id;
      this.$refs.topupDialog.openModal();
    },

    // 置顶
    async topupSubmitted(content) {
      this.topLoading = true;
      let res = await setHostTopUp(content);
      if (res.status == 200) {
        this.$message.success(res.msg);
        this.$refs.topupDialog.closeModal();
        this.getData();
      }
      setTimeout(() => {
        this.topLoading = false;
      }, 1000);
    },

    //取消置顶
    async cancelTopup(item) {
      if (item.is_loading) { return false };
      item.is_loading = true;
      event.stopPropagation(); // 阻止冒泡
      let res = await setHostTopUp({ id: item.ttar_id });
      if (res.status == 200) {
        this.$message.success(res.msg);
        this.getData();
      }
      setTimeout(() => {
        item.is_loading = false;
      }, 1000);
    },



    // 置精华
    async handleEssence(item) {
      if (item.is_loading) { return false }
      item.is_loading = true;
      event.stopPropagation(); // 阻止冒泡
      let res = await setHostEssence({ ttar_id: item.ttar_id });
      if (res.status == 200) {
        this.$message.success(res.msg);
        this.getData();
      }
      setTimeout(() => {
        item.is_loading = false;
      }, 1000);
    },

    // 删除
    async handleDel(event, ttar_id) {

      event.stopPropagation(); // 阻止事件冒泡
      if (!ttar_id) {
        this.$message({
          message: this.$t("暂未选择任何删除数据"),
          type: "error",
        });
      }
      if (ttar_id) {
        /** 弹窗再次确认操作 */
        this.$confirm(this.$t("此操作将删除该条记录, 是否继续?"), this.$t("提示"), {
          confirmButtonText: this.$t("确定"),
          cancelButtonText: this.$t("取消"),
          type: "warning",
        })
          /** 确认触发 */
          .then(async () => {
            /*请求接口删除数据*/
            const res = await setHostDelete({
              id: ttar_id,
            });
            if (res.status != 200) {
              return;
            }

            this.$message({
              type: "success",
              message: res.msg,
            });

            this.getData();
          })
          /** 取消触发 */
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("已取消删除操作"),
            });
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pageing-box {
  ::v-deep() {
    .el-pagination button:disabled {
      background-color: transparent;
    }

    .el-pager li {
      background: transparent;
    }

    .el-pagination .btn-prev,
    .el-pagination .btn-next {
      background-color: transparent;
    }

    .jump-ipt {
      box-sizing: border-box;
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 8px;
      background: rgb(255, 255, 255);
      width: 28px;
      height: 28px;
    }

    .jump-ipt .el-input__inner {
      padding: 0;
      height: 26px;
      line-height: 26px;
      border: none;
      position: relative;
      top: -2px;
      background-color: transparent;
    }
  }
}

.container {
  padding-top: 90px;
  padding-left: 80px;
  padding-right: 80px;
  padding-bottom: 36px;
  background: #f8f8f8;
  min-height: calc(100vh - 280px);

  .search-tab {
    max-width: 1400px;
    margin: 0 auto;
    padding-top: 40px;
    padding-bottom: 19px;

    .filter-btn {
      font-size: 16px;
      color: #999999;
      line-height: 20px;
      margin-right: 36px;
      position: relative;
      transition: all 0.36s;

      &:hover,
      &.active {
        color: #b7251e;
      }
    }
  }

  .search-box {
    max-width: 1400px;
    margin: 0 auto;

    .search-list {
      height: 54px;
      border-radius: 100px;
      border: 1px solid rgba($color: #b7251e, $alpha: 0.4);
      margin-right: 16px;
      transition: border 0.36s;
      overflow: hidden;

      &:hover {
        border: 1px solid rgba($color: #b7251e, $alpha: 1);
      }
    }

    .list5 {
      min-width: 114px;
      margin-right: 0;
      padding: 0 16px;
    }

    .list2,
    .list3,
    .list4 {}

    .list1 {
      width: 480px;
      padding-right: 30px;

      .btn {
        width: auto;
      }
    }

    ::v-deep() {
      .el-input__inner {
        height: 52px;
        border: none;
        background: transparent;
        padding-left: 20px;
        padding-right: 30px;
        color: #757575;

        &::placeholder {
          color: #757575;
        }
      }

      .el-input__suffix {
        right: 14px;
      }

      .el-select {
        width: 100%;
      }

      .el-select>.el-input {
        width: 100%;
      }

      .el-button--text {
        width: 100%;
        height: 52px;
      }
    }
  }

  .post-box {
    max-width: 1400px;
    margin: 0 auto;
    padding: 16px 26px;
    background: #ffffff;

    .list {
      padding-bottom: 28px;
      padding-top: 18px;
      position: relative;
      border-bottom: 1px solid rgba($color: #9f8686, $alpha: 0.2);
      cursor: pointer;

      &:last-child {
        border-bottom: none;
      }

      .btns {
        button {
          height: 32px;
          line-height: 32px;
          padding: 0 18px;
          border-radius: 20px;
          margin: 0;
          margin-left: 16px;
          font-size: 12px;
          transition: all 0.2s;
        }

        .btn1 {
          border-color: #fff0f1;
          background: #fff0f1;
          color: #b7251e;

          &:hover {
            border-color: #b7251e;
            background: #b7251e;
            color: #ffffff;
          }
        }

        .btn2 {
          border-color: #e2fffd;
          background: #e2fffd;
          color: #06ebb6;

          &:hover {
            border-color: #06ebb6;
            background: #06ebb6;
            color: #ffffff;
          }
        }

        .btn3 {
          border-color: #f6f6f6;
          background: #f6f6f6;
          color: #160404;
        }
      }

      &::after {
        content: "";
        height: 1px;
        width: 0%;
        background: #b7251e;
        position: absolute;
        bottom: 0;
        left: 0;
        transition: all 0.2s;
      }

      &:hover {
        .title {
          color: #b7251e;
        }

        &::after {
          width: 100%;
        }
      }

      .title {
        font-family: "MicrosoftYaHeiSemibold";
        color: rgb(25, 25, 25);
        font-size: 20px;
        font-weight: 400;
        line-height: 24px;
        padding: 2px 0;

        .essence,
        .hot {
          display: inline-block;
          min-width: 18px;
          height: 18px;
          border-radius: 2px;
          font-size: 14px;
          color: #ffffff;
          line-height: 18px;
          text-align: center;
          margin-right: 4px;
          position: relative;
          padding: 0 2px;
          top: -1px;
        }

        .essence {
          background: rgb(215, 17, 17);
        }

        .hot {
          background: rgb(255, 110, 0);
        }
      }

      .name {
        font-size: 16px;
        margin-left: 12px;
        line-height: 24px;
        position: relative;
        padding-right: 16px;

        &::after {
          content: "";
          display: inline-block;
          width: 1px;
          height: 14px;
          background: rgba($color: #9f8686, $alpha: 0.2);
          margin-left: 16px;
          position: absolute;
          top: 5px;
          right: 0;
        }
      }

      .date {
        font-size: 14px;
        color: #9f8686;
        line-height: 24px;
        margin-left: 12px;
      }

      .li {
        font-size: 14px;
        color: #9f8686;
        line-height: 24px;
        margin-left: 16px;

        .iconfont {
          margin-right: 4px;
        }
      }
    }
  }
}

@media screen and (max-width: 1400px) {
  .container .search-box .list1 {
    width: 360px;
  }
}

@media screen and (max-width: 1280px) {
  .container .search-box .list1 {
    width: 240px;
  }
}
</style>